import { create } from "zustand";

interface HeroStore {
  clickCount: number;

  incrementClick: () => void;
  resetClick: () => void;
  setClickCount: (value: number) => void;
}

export const useHeroStore = create<HeroStore>((set) => ({
  clickCount: 0,

  incrementClick: () =>
    set((state) => ({
      clickCount: state.clickCount + 1,
    })),

  resetClick: () => set({ clickCount: 0 }),

  setClickCount: (value) => set({ clickCount: value }),
}));
